<template>
    <div class="page-setting has-bc biz-todo-list-default">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}{{isAllGroup || isBizVerified != 'NORMAL'?'':' - '+userGroupName}}</h1>
            <div class="biz-view-mode">
                <div class="biz-view-mode-wrap">
                    <span class="list-mode" :class="{'active': mode == 'list'}" @click="changeMode('list')">
                        <img v-if="mode == 'list'" src="@/assets/img/icon/list_mode_black.svg" alt="">
                        <img v-else src="@/assets/img/icon/list_mode_gray.svg" alt="">
                        列表模式
                    </span>
                    <span class="map-mode" :class="{'active': mode == 'graph'}" @click="changeMode('graph')">
                        <img v-if="mode == 'graph'" src="@/assets/img/icon/map_mode_black.svg" alt="">
                        <img v-else src="@/assets/img/icon/map_mode_gray.svg" alt="">
                        圖表模式
                    </span>
                </div>
            </div>
        </div>
        <graph-mode v-if="mode == 'graph'"></graph-mode>
        <list-mode v-else-if="mode == 'list'"></list-mode>
    </div>
</template>
<script>
import graphMode from '@/components/bussiness/personalHome/todoList/graphMode/graphMode.vue';
import listMode from '@/components/bussiness/personalHome/todoList/listMode/listMode.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            mode: 'list'
        }
    },
    mounted () {
        if(this.$route.query.mode){
            this.mode = this.$route.query.mode
        }
    },
    methods: {
        changeMode: function (mode) {
            this.mode = mode
        }
    },
    computed: {
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
        })
    },
    components: {
        graphMode,
        listMode
    }
}
</script>
<style lang="scss">
    .biz-todo-list-default{
        .biz-view-mode{
            width: 204px;
            height: 44px;
            border: solid 1px #f0f0f0;
            background-color: #ffffff;
            border-radius: 4px;
            .biz-view-mode-wrap{
                display: flex;
                padding: 6px;
                span{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 94px;
                    height: 32px;
                    border-radius: 3px;
                    font-size: 12px;
                    color: #a8a5a4;
                    cursor: pointer;
                }
                span.active{
                    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
                    color: #676362;
                    background-color: #f6f6f6;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalHome/todoList/todoListDefault.vue